import React from 'react';

import Icons20x20 from './icons-20x20';
import Icons40x40 from './icons-40x40';
import FullFlags from './flag-full';
import styles from './styles.less';

const DEFAULT_SIZE = 20;

export type CountryCode = keyof typeof FullFlags;
interface Props {
	code: CountryCode | string;
	className?: string;
	name?: string;
	size?: number;
	fullSizeFlags?: boolean;
}

export const createCountryIconProps = (props: Props) => {
	const { code, className, name, size, fullSizeFlags } = props;

	const src = FullFlags[code as CountryCode];
	const smallImage = Icons20x20[code as CountryCode];
	const largeImage = Icons40x40[code as CountryCode];

	const options = fullSizeFlags
		? {
				src,
		  }
		: {
				src: largeImage,
				srcSet: `${smallImage} 1x, ${largeImage} 2x`,
		  };

	return {
		...options,
		alt: props.code,
		className: `${styles.icon} ${className}`,
		height: props.size,
		title: name || undefined,
		width: size || DEFAULT_SIZE,
	};
};

export default class CountryIcon extends React.PureComponent<Props> {
	static defaultProps = {
		size: DEFAULT_SIZE,
	};

	render() {
		return <img {...createCountryIconProps(this.props)} />;
	}
}
